import React, {useRef, useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import {useDispatch, useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {useAuthUser} from '../../utility/AppHooks';
import {IconButton, Grid, Box} from '@material-ui/core';
import PauseArrow from '@material-ui/icons/Pause';
import StopIcon from '@material-ui/icons/Stop';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import MicIcon from '@material-ui/icons/Mic';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '@material-ui/core/LinearProgress';
import ToasterMsg from '../../../@crema/core/AppLayout/ToasterMsg';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {Fonts} from '../../../shared/constants/AppEnums';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import DragAndDropUploaderDemo from './FileUploader';
// import lamejs from "lamejs";
import {
  PATIENT_COMPLETED_COUNT,
  PATIENT_COMPLETED_DATA,
  PRESIGN_URL_RES,
  AWS_PRESIGN_URL,
  PRESIGN_URL,
  UPLOAD_REC_RES,
  FETCH_SUCCESS,
} from '../../../shared/constants/ActionTypes';
import {getCGSPresignUrl, uploadRecordings} from '../../../redux/actions';
import {LiveAudioVisualizer} from 'react-audio-visualize';
const passKey = 'DI~8w185lPO';

// style applied to this page
const useStyles = makeStyles((theme) => ({
  rootdialog: {
    margin: 0,
    padding: theme.spacing(2),
  },
  alignCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  alignCenter1: {
    display: 'flex',
    justifyContent: 'center', // center horizontally
    alignItems: 'center', // center vertically
    gap: '10px',
  },
  dialogHeader: {
    backgroundColor: '#2e4167',
    padding: 0,
    alignItems: 'center',
    paddingLeft: '6px',
    borderBottom: ['1px solid #afa2a2a6'],
  },
  dialogheadStyle: {
    padding: 5,
    color: '#fff',
  },
  dialogTitle: {
    fontWeight: 'bold',
    marginBottom: 0,
    fontSize: Fonts.TableHeader,
    fontStyle: Fonts.FONTSTYLE,
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
  },
  closeBtn: {
    padding: 5,
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'end',
    color: 'white',
  },
  closeBtnColor: {
    color: '#fff',
  },
  dialogActions: {
    justifyContent: 'end',
    display: 'flex',
    padding: '3px',
  },
  buttonStyle: {
    background: '#0a8fdc',
    color: 'white',
    '&:hover': {
      background: '#0a8fdc',
      color: 'white',
    },
  },
  doneButtonStyle: {
    background: '#8B00F7',
    color: 'white',
    textTransform: 'capitalize',
    padding: '8px 12px',
    '&:hover': {
      background: '#8B00F7',
      color: 'white',
    },
  },
  redcolor: {
    color: '#ffff00 !important',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#ffff00 !important',
    },
  },
  greencolor: {
    color: '#FFBF00	 !important',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: '#FFBF00	 !important',
    },
  },
  radioStyle: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'row',
    },

    [theme.breakpoints.down('md')]: {
      '& .MuiTypography-body1': {
        fontSize: '12px !important',
      },
    },
  },
  disdoneButtonStyle: {
    background: '#8080809c',
    textTransform: 'capitalize',
    padding: '8px 12px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogwidth: {
    '& .MuiDialog-paperWidthSm': {
      minWidth: '50%',
      minHeight: '30%',
    },
    padding: '5px',
    '& .MuiLinearProgress-colorPrimary': {
      background: '#6495ED',
      '& .MuiLinearProgress-barColorPrimary': {
        background: '#0000A3',
      },
    },
  },
  btnblue: {
    textTransform: 'capitalize',
    background: '#2e4167',
    color: '#ffffff',
    '&:hover': {
      background: '#2e4167',
      color: '#ffffff',
    },
  },
  btnred: {
    background: '#ff7252',
    color: '#ffffff',
    '&:hover': {
      background: '#ff7252',
      color: '#ffffff',
    },
  },

  dialogactionsclass: {
    marginBottom: '10px !important',
    marginTop: '10px !important',
  },
}));
const crypto = require('crypto');
var algorithm = 'aes-256-ctr'; // Encryption algorithm
var password = 'd6F3Efeq';

const AudioInput = ({opendialog, onDeny}) => {
  const classes = useStyles();
  const [startAudio, setStartAudio] = useState(false);
  const [loading, setloading] = useState(false);
  const [timer, setTimer] = useState(0);
    const userAccess = useSelector(
      ({auth}) => auth.user
    );
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [mp3Blob, setmp3Blob] = useState('');
  const [mp3uplBlob, setmp3uplBlob] = useState('');
  const [genFileName, setgenFileName] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [audiofunc, setaudiofunc] = useState('1');
  const [snackbaropen, setsnackbaropen] = React.useState(false);
  const [patientExist, setPatientExist] = React.useState('');
  const [varianttype, setvarianttype] = React.useState('error');
  const [startTime, setStartTime] = useState(null);
  const [pausedTime, setPausedTime] = useState(0);
  const [lastPauseTime, setLastPauseTime] = useState(null);
  const [uploadComplete, setUplaodComplete] = React.useState(false);
  const timerRef = useRef(null);
  const user = useAuthUser();
  const dispatch = useDispatch();
  const [recUrl, setRecUrl] = useState('');
  const clearRecord = async () => {
    stopRecording();
    setRecUrl('');
    setmp3Blob('');
    setTimer(0);
    setgenFileName('');
    setStartTime(0);
    setLastPauseTime(0);
    setPausedTime(0);
  };
  const getPresignUrl = useSelector(({dashboard}) => dashboard.presignurl);
  const getawsPresignUrl = useSelector(
    ({dashboard}) => dashboard.awspresignurl,
  );
  const presignurlRes = useSelector(({dashboard}) => dashboard.presignurlRes);
  const uploadRecRes = useSelector(({dashboard}) => dashboard.uploadRecRes);
  useEffect(() => {
    if (uploadRecRes != '' && uploadRecRes === 'Success') {
      clearRecord();
      setvarianttype('success');
      if (audiofunc == 1) setPatientExist('Recording uploaded successfully!');
      else setPatientExist('Audio uploaded successfully!');

      setsnackbaropen(true);
      dispatch({
        type: UPLOAD_REC_RES,
        payload: '',
      });
      setTimeout(() => {
        onDeny(false);
      }, 3000);
      // setsnackbaropen(false);
    }
  }, [uploadRecRes]);
  useEffect(() => {
    if (presignurlRes !== '' && presignurlRes === 'Success') {
      (async () => {
        await Promise.all([uploadRecord(), awsuploadRecord()]);
        // Now reset presignurlRes after both are done
        dispatch({
          type: PRESIGN_URL_RES,
          payload: '',
        });
        insertDBRecord();
        setloading(false);
      })();
    }
  }, [presignurlRes]);
  function insertDBRecord() {
    let passData = {
      awsUrl: getawsPresignUrl.split('?')[0],
      gcsUlr: getPresignUrl.split('?')[0],
      doctorCode: Number(user.doctorCode),
      fileName: genFileName,
    };
    dispatch(uploadRecordings(passData));
  }

  async function uploadRecord() {
    if (getPresignUrl) {
      const res = await fetch(getPresignUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'audio/mpeg', // Must match the one used in signed URL generation
        },
        body: mp3Blob ? mp3Blob : mp3uplBlob,
      });

      if (!res.ok) {
        throw new Error(`Upload failed with status ${res.status}`);
      } else {
        dispatch({
          type: PRESIGN_URL,
          payload: '',
        });
      }
      console.log('Upload successful!');
    }
  }

  async function awsuploadRecord() {
    if (getawsPresignUrl) {
      const res = await fetch(getawsPresignUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'audio/mpeg', // Must match the one used in signed URL generation
        },
        body: mp3Blob ? mp3Blob : mp3uplBlob,
      });

      if (!res.ok) {
        throw new Error(`Upload failed with status ${res.status}`);
      } else {
        dispatch({
          type: AWS_PRESIGN_URL,
          payload: '',
        });
      }
    }
  }
  const startRecording = async () => {
    if (isRecording == false) {
      const stream = await navigator.mediaDevices.getUserMedia({audio: true});
      const recorder = new MediaRecorder(stream);
      mediaRecorderRef.current = recorder;
      setMediaRecorder(recorder);
      setStartAudio(true);
      setIsRecording(true);
      audioChunksRef.current = [];
      mediaRecorderRef.current.ondataavailable = (e) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };
      mediaRecorderRef.current.start();
      setTimer(0);
      timerRef.current = setInterval(() => setTimer((t) => t + 0.01), 10);
      setStartTime(Date.now());
    }
  };
  const pauseRecording = () => {
    if (mediaRecorderRef.current?.state === 'recording') {
      mediaRecorderRef.current.pause();
      clearInterval(timerRef.current);
      setLastPauseTime(Date.now());
      setIsRecording(false);
    }
  };

  const resumeRecording = () => {
    if (mediaRecorderRef.current?.state === 'paused' && isRecording == false) {
      mediaRecorderRef.current.resume();
      timerRef.current = setInterval(() => setTimer((t) => t + 0.01), 10);
      setIsRecording(true);
      setPausedTime((prev) => prev + (Date.now() - lastPauseTime));
      setLastPauseTime(null);
    }
  };
  const getElapsedTime = () => {
    if (!startTime) return 0;
    if (isRecording) {
      return (Date.now() - startTime - pausedTime) / 1000;
    } else if (lastPauseTime) {
      return (lastPauseTime - startTime - pausedTime) / 1000;
    }
    return 0;
  };
  const stopRecording = () => {
    if ((startAudio == false && isRecording == false && recUrl) == false) {
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state !== 'inactive'
      ) {
        mediaRecorderRef.current.onstop = () => {
          // Combine all recorded chunks
          const audioBlob = new Blob(audioChunksRef.current, {
            type: 'audio/webm',
          });
          const audioUrl = URL.createObjectURL(audioBlob);
          setRecUrl(audioUrl);
          setmp3Blob(audioBlob);
          // Optional: auto-download
          //   const a = document.createElement("a");
          //   a.href = audioUrl;
          //   a.download = "recording.webm";
          //   a.click();
        };

        mediaRecorderRef.current.stop(); // ✅ stops and triggers onstop
        clearInterval(timerRef.current); // stop timer
        setStartAudio(false);
        setIsRecording(false);
      }
    }
  };

  const clickPlay = () => {
    if (isRecording && startAudio) {
      pauseRecording();
    } else {
      if (
        mediaRecorderRef.current &&
        mediaRecorderRef.current.state === 'paused'
      ) {
        resumeRecording();
      } else {
        startRecording();
      }
      setStartAudio(true);
    }
  };
  const encryptpassword = function ({data}) {
    var cipher = crypto.createCipher(algorithm, password); // Create cipher instance
    var enc = cipher.update(data, 'utf8', 'hex'); // Encrypt data from 'utf8' to 'hex'
    enc += cipher.final('hex'); // Final step of encryption
    return enc; // Return the encrypted data
  };
  const saveAudio = () => {
    if (startAudio == false && isRecording == false && recUrl) {
      let passCode = passKey + '_' + Date.now();
      let newCode = encryptpassword({data: passCode});
      //gen file name
      setloading(true);
      let fileName = 'doceRx_' + user.doctorCode + '_' + Date.now();
      setgenFileName(fileName);
      dispatch(
        getCGSPresignUrl({
          accessKey: newCode,
          fileName: fileName,
          doctorCode: Number(user.doctorCode),
        }),
      );
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if(opendialog && audiofunc =='1'){
          if (event.keyCode == '13' && event.ctrlKey && userAccess?.medEcho) {
        event.preventDefault();
        saveAudio();
      }

      if (event.key == '1' && event.ctrlKey && userAccess?.medEcho ) {
        event.preventDefault();
        clickPlay();
      }

      if (event.key == '2' && event.ctrlKey && userAccess?.medEcho) {
        event.preventDefault();
        stopRecording();
      }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [saveAudio, clickPlay, stopRecording]);

  const formatMinute = (time) => {
    if (time > 60) {
      const minutes = Math.floor(time / 60);
      return `${String(minutes).padStart(2, '0')}:`;
    } else {
      return `00:`;
    }
  };
  const formatSecond = (time) => {
    if (time == 0) {
      return `00.00`;
    } else if (time > 60) {
      const remainingSeconds = (time % 60).toFixed(2);
      let sec = remainingSeconds
        ? remainingSeconds < 10
          ? `0${remainingSeconds}`
          : remainingSeconds
        : '00.00';
      return sec;
    } else {
      let sec = time < 10 ? `0${time.toFixed(2)}` : time.toFixed(2);
      return sec;
    }
  };
  function closePopup() {
    clearRecord();
    onDeny(false);
  }
  const diabetesChangeEvent = (event) => {
    // if(audiofunc != event.target.value){
    //   clearRecord()
    //   setmp3uplBlob('')
    // }
    const selectedValue = event.target.value;
    if (
      (audiofunc === '1' &&
        selectedValue === '2' &&
        startAudio == false &&
        isRecording == false &&
        recUrl) ||
      startAudio == true
    ) {
      setvarianttype('error');
      setPatientExist(
        'Please complete the recording before switching to Uploader.',
      );
      setsnackbaropen(true);
      return; // Block switch
    }
    setaudiofunc(event.target.value);
  };

  return (
    <Box style={{position: 'relative'}}>
      <Dialog
        open={opendialog}
        onClose={() => onDeny(false)}
        className={classes.dialogwidth}>
        {loading && (
          <>
            <div
              style={{
                display: 'flex',
                position: 'fixed',
                top: '47vh',
                zIndex: 2000,
                width: '46vw',
                justifyContent: 'center',
              }}>
              <p style={{zIndex: 2000, fontWeight: 'bold'}}>Uploading...</p>
            </div>
            <div
              style={{
                display: 'flex',
                position: 'fixed',
                top: '49vh',
                zIndex: 2000,
                width: '46vw',
                justifyContent: 'end',
              }}>
              <LinearProgress
                style={{
                  position: 'fixed',
                  top: '50vh',
                  left: '29vw',
                  right: 0,
                  zIndex: 2000,
                  width: '40vw',
                }}
              />
            </div>

            {/* Overlay to disable UI */}
            <Box
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255,255,255,0.8)',
                zIndex: 1500,
              }}
            />
          </>
        )}
        <div></div>
        <Grid container className={classes.dialogHeader}>
          <Grid item={true} xs={5} md={5} className={classes.dialogheadStyle}>
            <Box
              component='h4'
              fontWeight={Fonts.REGULAR}
              className={classes.dialogTitle}
              id='userDialogTitle'>
              MediEcho Audio Recording Panal
            </Box>
          </Grid>
          <Grid item={true} xs={7} md={7} className={classes.closeBtn}>
            <div>
              <RadioGroup
                aria-label='func'
                name='func'
                value={audiofunc}
                onChange={diabetesChangeEvent}
                className={classes.radioStyle}>
                <FormControlLabel
                  value='1'
                  control={<Radio name='radio1' className={classes.redcolor} />}
                  label='Recorder'
                />
                <FormControlLabel
                  value='2'
                  control={
                    <Radio name='radio1' className={classes.greencolor} />
                  }
                  label='Uploader'
                />
              </RadioGroup>
            </div>
            <IconButton onClick={() => closePopup()}>
              <HighlightOffIcon className={classes.closeBtnColor} />
            </IconButton>
          </Grid>
        </Grid>
        <ToasterMsg
          snackbaropen={snackbaropen}
          variantdata={varianttype}
          msgdata={patientExist}
          onDeny={setsnackbaropen}
        />
        <div style={{minHeight: '50vh', padding: '5px'}}>
          {audiofunc == 2 ? (
            <DragAndDropUploaderDemo
              passKey={passKey}
              encryptpassword={encryptpassword}
              setgenFileName={setgenFileName}
              setmp3uplBlob={setmp3uplBlob}
              setloading={setloading}
            />
          ) : (
            <>
              <Box
                style={{
                  border: '1px solid #CFCFCF',
                  margin: '1rem',
                  borderRadius: '5px',
                  minHeight: 100,
                }}>
                {mediaRecorder ? (
                  <Box
                    style={{width: '100%', height: '100%', overflow: 'hidden'}}>
                    <LiveAudioVisualizer
                      mediaRecorder={mediaRecorder}
                      barColor='#f76565'
                      barWidth={2}
                      gap={1}
                      width={730}
                      height={100}
                      style={{
                        display: 'block',
                        width: '100%',
                      }}
                    />
                  </Box>
                ) : (
                  <canvas
                    style={{
                      backgroundColor: 'transparent',
                      display: 'block',
                      height: '100%',
                      width: '100%',
                    }}
                    width={600}
                    height={100}
                    barWidth={2}
                    gap={1}
                    ref={(canvas) => {
                      if (!canvas) return;
                      const ctx = canvas.getContext('2d');
                      ctx.clearRect(0, 0, canvas.width, canvas.height);

                      // Draw flat placeholder line
                      ctx.strokeStyle = '#f76565';
                      ctx.lineWidth = 2;
                      ctx.beginPath();
                      ctx.moveTo(0, canvas.height / 2);
                      ctx.lineTo(canvas.width, canvas.height / 2);
                      ctx.stroke();
                    }}
                  />
                )}
              </Box>
              <Box className={classes.dialogContent}>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '1rem',
                  }}>
                  <h2>{formatMinute(getElapsedTime())}</h2>
                  <h2>{formatSecond(getElapsedTime())}</h2>
                </Box>

                <Grid
                  container
                  spacing={2}
                  style={{justifyContent: 'center', gap: '0 5px'}}>
                  <Grid item>
                    <Tooltip title='Clear' arrow>
                      <IconButton
                        className={classes.buttonStyle}
                        onClick={clearRecord}
                        disabled={recUrl ? false : true}
                        style={
                          recUrl
                            ? {backgroundColor: '#07649A'}
                            : {background: '#8080809c'}
                        }>
                        <SettingsBackupRestoreIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title={isRecording ? 'Pause' : 'Record'} arrow>
                      <IconButton
                        onClick={clickPlay}
                        className={classes.buttonStyle}
                        style={{
                          background: isRecording ? '#0a8fdc' : '#00B59C',
                        }}>
                        {isRecording ? <PauseArrow /> : <MicIcon />}
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title='Stop' arrow>
                      <IconButton
                        onClick={stopRecording}
                        className={classes.buttonStyle}
                        style={
                          startAudio == false && isRecording == false
                            ? {background: '#8080809c'}
                            : {background: 'red'}
                        }
                        disabled={
                          startAudio == false && isRecording == false
                            ? true
                            : false
                        }>
                        <StopIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{justifyContent: 'center', marginTop: '1rem'}}>
                  <Grid item>
                    <Button
                      onClick={saveAudio}
                      className={
                        startAudio == false && isRecording == false && recUrl
                          ? classes.doneButtonStyle
                          : classes.disdoneButtonStyle
                      }
                      startIcon={<CloudUploadIcon />}
                      disabled={
                        startAudio == false && isRecording == false && recUrl
                          ? false
                          : true
                      }>
                      Upload
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </div>
      </Dialog>
    </Box>
  );
};

export default AudioInput;
AudioInput.propTypes = {
  opendialog: PropTypes.bool.isRequired,
  onDeny: PropTypes.func.isRequired,
};
